import { useEffect, useState } from "react";

// True on touch / coarse-pointer devices (phones, tablets) where hover-based
// 3D tilt is meaningless and heavy composited layers flicker while scrolling.
export const useCoarsePointer = () => {
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(hover: none), (pointer: coarse)");
    setCoarse(query.matches);
    const handler = (e) => setCoarse(e.matches);
    query.addEventListener("change", handler);
    return () => query.removeEventListener("change", handler);
  }, []);

  return coarse;
};
